/**
 * Entry point for development and production PWA builds.
 */
import 'regenerator-runtime/runtime';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
/**
 * EXTENSIONS AND MODES
 * =================
 * pluginImports.js is dynamically generated from extension and mode
 * configuration at build time.
 *
 * pluginImports.js imports all of the modes and extensions and adds them
 * to the window for processing.
 */
import loadDynamicImports, { loadRuntimeImports } from './pluginImports.js';

(function () {
  const auth = sessionStorage.getItem('auth');
  const url = window.location.href;
  const isTargetRoute = url.includes('startDate') || url.includes('endDate') || url.includes('pageNumber') || url.includes('resultsPerPage') || url.includes('sortBy') || url.includes('sortDirection');

  if (isTargetRoute && !auth) {
    window.location.href = '/';
  }
})();


loadDynamicImports().then(() => {
  loadRuntimeImports(window.config).then(() => {
    /**
     * Combine our appConfiguration with installed extensions and modes.
     * In the future appConfiguration may contain modes added at runtime.
     *  */
    const appProps = {
      config: window ? window.config : {},
      defaultExtensions: window.extensions,
      defaultModes: window.modes,
    };

    /** Create App */
    const app = React.createElement(App, appProps, null);
    /** Render */
    ReactDOM.render(app, document.getElementById('root'));
  });
});